import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    fetchUnits: [],
    fetchUnitsSuccess: ['items'],
    fetchUnitsFailure: ['error'],

    createUnit: ['unit', 'query'],
    createUnitSuccess: ['unit'],
    createUnitFailure: ['error'],

    deleteUnit: ['id', 'query'],
    deleteUnitSuccess: ['items'],
    deleteUnitFailure: ['error'],
});


export const UnitTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    loading: false,
    error: null,
    items: [],
    createdUnit: null
})

const resetState = () => INITIAL_STATE;

export const reducer = createReducer(INITIAL_STATE, {

    // Fetch work order actions
    [Types.FETCH_UNITS]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            items: [],
        };
    },

    [Types.FETCH_UNITS_SUCCESS]: (state, {items}) => {
        return {
            ...state,
            items,
            loading: false,
            error: null,
            lastSyncDt: new Date().getTime(),
        };
    },

    [Types.FETCH_UNITS_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            items: [],
        };
    },

    // Create an work order
    [Types.CREATE_UNIT]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
            createdUnit: null,
        };
    },

    [Types.CREATE_UNIT_SUCCESS]: (state, { unit }) => {
        return {
            ...state,
            loading: false,
            createdUnit: unit,
            error: null,
        };
    },

    [Types.CREATE_UNIT_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            unit: null,
            createdUnit: null,
        };
    },

    // Delete an existing work order
    [Types.DELETE_UNIT]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            deletedItem: null,
        };
    },

    [Types.DELETE_UNIT_SUCCESS]: (state, action) => {
        return {
            ...state,
            loading: false,
            error: null,
            deletedItem: true,
        };
    },

    [Types.DELETE_UNIT_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            deletedItem: null,
        };
    },
});



// WEBPACK FOOTER //
// ./src/Redux/UnitRedux.js